import rentalReturnImg1 from '@/assets/images/dummy.svg';
import rentalReturnImg2 from '@/assets/images/dummy2.svg';
import rentalReturnImg3 from '@/assets/images/dummy3.svg';

export const RENTAL_RETURN_IMAGE = [
  rentalReturnImg1,
  rentalReturnImg2,
  rentalReturnImg3,
];
